// Temporary iframe context detection using sessionStorage
// This is cleared when the browser tab closes

const IFRAME_KEY = 'is_in_iframe'

export const IframeContext = {
  // Set iframe context (call from PowerSchool login)
  setInIframe(value: boolean): void {
    if (value) {
      sessionStorage.setItem(IFRAME_KEY, 'true')
    } else {
      sessionStorage.removeItem(IFRAME_KEY)
    }
  },

  // Check if currently in iframe context
  isInIframe(): boolean {
    return sessionStorage.getItem(IFRAME_KEY) === 'true'
  },

  // Clear iframe context
  clear(): void {
    sessionStorage.removeItem(IFRAME_KEY)
  }
}
